import { CommonData } from "../../../common/datastructures/gamestate/gameData";
// import { Environment } from "../bg_environment";
import { BonusGameInfoUI } from "../GameSpinner/bonusGameUI/BonusGameSpinsInfoUI";
import { GameText } from "../datastructures/GameText";
import { SpinGame } from "../GameSpinner/GameSpin";
import { PayTableBuilder } from "../PaytableInGame";
import {
  resetAllBtns,
  disableAllBtns,
  clearOnReplayOpenClose,
  expandSuccess,
} from "../inGameFunction";
import {
  requestNewBalance,
  setAllowedInputs,
} from "../../../common/functions/Functions_General";
import { Backgroundsky } from "../../../common/gameLib/bg_sky";
import { Environment } from "../background/bg_environment";
import { GamePayTableBuilder } from "../../../common/gameLib/GamePayTableLib/gamePayTable_Class";
// import { API_Abs } from "../../../common/gameLib/api_Abstraction";
import { Howl } from "howler";
import { API_Abs2 } from "../../../common/gameLib/api_AbstractionPandoraBox";

import {  TalesOfTimeWinCombination, TalesOfTimeGameContext } from "../datastructures/bookOfX_Interface";
// import { SergioWinAnimation } from "../gameWin/gameWinAnimation";
import { NewWinAnimation } from "../gameWin/winAnimation/winAnimationBuilder";
import { loginResponseData } from "../../../common/gameLib/APIModels/gameLogin";
import { generateVersion } from "../../../common/functions/cookies";
import DeviceChecker from "../../../common/functions/helper.ts/DeviceChecker";
import { MinimumStakeDisplayPopup } from "../../../common/gameLib/MiniumStakePopup/miniumStakePopup";


export class GameData extends CommonData {
  public override gameName: string = "Tales of Time : Egypt";
  public API_handler: API_Abs2;
  public allDice: Array<string>;
  public bonusGameInfos: BonusGameInfoUI; //bonus game INFOS Display UI
  public diceCounter: number;
  public gameText: GameText;
  public mainGame: SpinGame;
  // public bonusGame: any;
  public bonusGameMusic: Howl;
  public NormalGameMusic: Howl;
  public NormalGameMusic2: Howl;
  public NewWinSound: Howl;
  public expandAnimSound:Howl;
  public sound_reelStop:Howl;
  public sound_expandComlete:Howl
  public sound_bellRing:Howl;
  public sound_epicBonusEnd:Howl;
  public giftBoxWin:Howl;
  public gamePayTableValues: GamePayTableBuilder;


  public GamePayTableBuilder: Function;

  public paytable: PayTableBuilder;
  public pointValue: number;
  public points: Array<number>;
  public prizesMultiplier: Array<number>;
  public skipReelOnFlameAnimation: boolean;
  public sound: Howl;
  //  public soundList: Array<Howl>;
  public soundVolume: number;
  public tileImgEnd: Array<number>;
  public tileImgName: Array<string>; //['diceone','dicetwo','dicethree','dicefour','dicefive','dicesix','dicek3','dicek4','dicek5','diceks'];;
  
  public   tileImgNamePast: Array<string>; //[
  public tileImgNameBlurred: Array<string>;
  public tileImgStart: Array<number>; //=[23,23,23,23,23,23,23,23,23,23];
  //--------
  public background: Backgroundsky;
  public environment: Environment;

  public scatterList: Array<TalesOfTimeWinCombination>;
  public winlinnesList: Array<TalesOfTimeWinCombination>;
  public collectableList: Array<TalesOfTimeWinCombination>;

  public santaExpandable: boolean;
  public winCombinaison:TalesOfTimeWinCombination;
  public expandRequested:boolean;
  public isExpanding:boolean=false;
  public ExpandSantaSuccess:Function;
  public canSkipExpand:boolean=false;
  public canSkipBonusSelectSymbol:boolean=false;
  // public sergioWinAnimation:SergioWinAnimation;
  public newWinAnimation:NewWinAnimation;
  public loginResponse: loginResponseData;
  public override useSpinOnReplayInsteadOfRecovery
    = true;///-enable or disable to use instead of revocery function while spiining with reel ! need changes to make it work ingame //default is false
  
  constructor() {
    super();
   
    this.expandRequested=false;
    this.diceCounter = 0;
    this.gameFPS = 60;
    this.pointValue = 0;
    this.points = [];
    this.prizesMultiplier = [];
    this.skipReelOnFlameAnimation = false;
    this.soundVolume = 1;
 this.gameVersion = generateVersion(); 

    this.santaExpandable = false;
    this.scatterList = [];
    this.winlinnesList = [];
    this.collectableList = [];

    this.normalGameMusic = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      // src: [
      //   "sounds/Egyptian Oasis Loop.mp3?" +
      //     "version=" +
      //     this.gameVersion,
      // ],
      // volume: 1,
      
      // // html5:true,
      // sprite: {
   
      //   music: [0, 122285, true],
      src: [
        "sounds/Ancient-Egypt-music-LOOP_AdobeStock_513024062_01.mp3?" +
          "version=" +
          this.gameVersion,
      ],
      volume: .25,
      
      // html5:true,
      sprite: {
   
        music: [0, 35068, true],
      },
    });
    // this.normalGameMusic.fade(0, 1, 100);
    // this.normalGameMusic.fade(0, 1, 5000);
    this.bonusGameMusic = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: ["sounds/Ancient Egyptian Choir (short) - AllenGrey.mp3?" + "version=" + this.gameVersion],
      volume: .5,
      sprite: {
        bonus: [16655, 40782-16655, true],
      },
    });

    this.sound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: ["sounds/sound_sprite.m4a?" + "version=" + this.gameVersion],
      volume: 1,
      sprite: {
        rollStop: [128, 150, false],
        winline: [875, 1500, false],
        drum: [2360, 1805, false],
      },
    });

    this.giftBoxWin = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: ["sounds/Egyptian Start Quest.mp3?" + "version=" + this.gameVersion],
      volume: 0.25,
      sprite: {
        bonus: [0, 5084, false],
     
      },
    });
    this.NewWinSound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      // src: [
      //   "sounds/mixedGamePack.mp3?" +
      //     "version=" +
      //     this.gameVersion,
      // ],
      // volume: 0.7,
      // sprite: {
      //   winline: [8566, 2509, false],
        

      // },
      src: [
        "sounds/Ancestral Win.mp3?" +
          "version=" +
          this.gameVersion,
      ],
      volume: .7,
      sprite: {
        winline: [0, 2643, false],
        

      },
    });
    this.expandAnimSound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
			src: ['sounds/EgyptianPrize.mp3?' + "version=" + this.gameVersion],
			volume: 1,
			sprite: {
				win: [0, 7244, false],
			}

		});

    this.sound_reelStop = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
			src: ['sounds/Epic_Button_Click_1.mp3?' + "version=" + this.gameVersion],
			volume: 1,
			sprite: {
				sound: [0, 1733, false],
			}

		});


    this.sound_expandComlete = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
			src: ['sounds/Egyptian Award_01.mp3?' + "version=" + this.gameVersion],
			volume: 1,
			sprite: {
				sound: [0, 3000, false],
			}

		});

    
		this.sound_bellRing = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
			src: ['sounds/BellsSchoolBell.mp3?' + "version=" + this.gameVersion],
			volume: 1,
			sprite: {
				sound: [0, 7244, false],
			}

		});

     
		this.sound_epicBonusEnd = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
			src: ['sounds/Epic Egyptian Fanfare_01.mp3?' + "version=" + this.gameVersion],
			volume: 1,
			sprite: {
				sound: [0, 11332, false],
			}

		});





    this.soundList.push(this.sound);
    this.soundList.push(this.NewWinSound);
    this.soundList.push( this.giftBoxWin);
    this.soundList.push(this.expandAnimSound);
    this.soundList.push(this.sound_reelStop);
    this.soundList.push(this.sound_expandComlete);
    this.soundList.push(this.sound_epicBonusEnd);
    this.soundList.push(this.sound_bellRing);
    this.normalGameMusicList = [];
    this.bonusMusicList = [];
    this.normalGameMusicList.push(this.normalGameMusic);
    // this.normalGameMusicList.push(this.normalGameMusic2);
    this.bonusMusicList.push(this.bonusGameMusic);

    this.tileImgNameBlurred = [
      "symbol10",
      "symbolJ",
      "symbolQ",
      "symbolK",
      "symbolA",
      "symbolCross",
      "symbolInsect",
    
      "symbolEye",
      "symbolTuto",
      "symbolScroll",
      "void_00000",
    ]; //k5 unused
    // this.tileImgName = ['dice_one', 'dice_two', 'dice_three', 'dice_four', 'dice_five', 'dice_six', 'dice_ks', 'dice_ks', 'fireOrbAnim', 'void', 'void'];
    this.tileImgName = [
      "symbol10",
      "symbolJ",
         
   "symbolQ",
      "symbolK",
      "symbolA",
      "symbolCross",
      "symbolInsect",  
      "symbolEye",  
        
      "symbolTuto",
      // "symbolMan",
      "symbolScroll",
      "void",
    ];

    this.tileImgNamePast = [
      "symbol10",
      "symbolJ",
       "symbolQ",
      "symbolK",
      "symbolA",
      "symbolCrossPast",   
      "symbolInsectPast",  
   
      "symbolEyePast",   
       
      "symbolTutoPast",
      // "symbolMan",
      "symbolScroll",
      "void",
    ];
    this.tileImgStart = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // start frame
    this.tileImgEnd = [11, 11, 11, 11, 11, 20, 20,20,46, 20, 11]; ////end frame not inculde
    // this.tileImgStart = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // start frame
    // this.tileImgEnd = [17, 17, 17, 17, 17, 17, 17,17, 17, 17, 11, 11, 11]; ////end frame not inculde

    // this.points = [100, 150, 200, 250, 300, 400, 500, 700, 1000];
    // this.prizesMultiplier = [2, 3, 4, 5, 6, 8, 20, 60, 100];
    this.allDice = this.tileImgNamePast;

    this.autoPlayTicker = new PIXI.ticker.Ticker();
    this.autoPlayTicker.stop();
    this.autoPlayTicker.add(() => {
      if (
        this.mainGame.getIsGameStarted() === false &&
        this.winAnimation.isActive() === false
      ) {
        this.playFunction(); //start game
        // activeGameData.autoPlayTicker.stop();
      }
    });

    //    console.log("load audio")
    this.defineFunctions = this.setFunctions;
    this.gameId = 100018//100008;
    // this.betResponse={"statusCode":"0","balance":{},"gameContext":{}}
    this.gameDefault();
    this.clearOnReplayOpenClose = (): void => {
      clearOnReplayOpenClose(this);
    };

    //define default game scale value and offset for portrait mode of the game
    this.portraitGameSceneScale = [1.435, 1.43];
    this.portraitGameSceneOffset = [4.95, 9]; //divider
    this.portraitScalemainMask = 1.1;
    this.scaleMessageBoxPortrait = 1.6;

    //--

    this.GamePayTableBuilder = GamePayTableBuilder;
    this.API_handler = new API_Abs2(this.gameId,this); //new API_Abs(this.gameId);
  }
      public override addMinimumStakePopupTo = (parentContainer: PIXI.Container): void => {
        this.minimumStakePopup = new MinimumStakeDisplayPopup(this);
    
        parentContainer.addChild(this.minimumStakePopup);
        this.minimumStakePopup.x = this.size[0] / 2;
        this.minimumStakePopup.y = this.size[1] / 2;
    
        this.minimumStakePopup.setPortraitPositionY(this.size[1] / 2+50);
        this.minimumStakePopup.setLandScapePositionY(this.size[1] / 2 - 165);
  };
  public setFunctions() {
    this.requestNewBalance = requestNewBalance;
    this.setAllowedInputs = setAllowedInputs;
    this.resetAllBtns = resetAllBtns;
    this.disableAllBtns = disableAllBtns;
    this.ExpandSantaSuccess= (data: any): void => { expandSuccess(data, this) };
    this.setGameElementsPortraits=this.setGameElementPortraitOnResize//-empty function
    // this.onBetBuySuccessFunction= onPlayButtonDown;
    // this.playFunction
  }


 



private setGameElementPortraitOnResize=(isLandScape:boolean):void=>
{ 
  // console.log(isDesktop)
  if(this.mainGame!=undefined)
  {
    this.mainGame.getBonusSymbolPickedOverlay().isLandScape(isLandScape);
    this.mainGame.getBonusSymbolPickerBookAnimation().setPortraitMode(isLandScape);
  }
  if(this.paytable!=undefined)
  {
    // console.log(isLandScape)
    this.paytable.setOrientationLanscape(isLandScape)
  }

}
  public GameContext = (): TalesOfTimeGameContext => {
    return this.betResponse.gameContext.contextData as TalesOfTimeGameContext;
  };

  private gameDefault() {
    this.betResponse = {
      playerBalance: {
        creditsBalance: {
          amount: 0,
          currency: "EUR",
        },
        freeGamesBalance: {},
      },
      gameContext: {
        contextNumber: 0,
        contextData: {
    

          contextType: "DEFAULT",
          allowedInputActions: ["BET"],
          baseGameResult:{
            reels:  [  [1, 1, 1],
            [2, 2, 2],
            [3,3,3],
            [4, 4, 4],
            [5, 5, 5]],
            expandedWildReels:[],
            winCombinations:[]
          } ,
          bonus: false,
          finished: true,
          gambleHistory: [],
          gameRoundBalance: {
            credits: { amount: 0, currency: "EUR" },
            bonusSpins: 0,
          },
          stake: { amount: 0, currency: "EUR" },
          usedInputAction: "BET",
          win: { credits: { amount: 0, currency: "EUR" }, bonusSpins: 0 },
          winCombinations: [],
        },
      },
    };
  }
}
